import { useQuery } from "@tanstack/react-query";
import { fetchProfileApi } from "../api/profileApi";

export const useFetchProfile = ({ contactId, campaignId, userId }) => {
  return useQuery({
    queryKey: ["profile", contactId, campaignId ?? null, userId],
    queryFn: () =>
      fetchProfileApi({
        contact_id: contactId,
        campaign_id: campaignId ?? null,
        user_id: userId,
      }),
    enabled: !!contactId && !!userId,
  });
};